module.exports = __webpack_public_path__ + "img/payment.05da8c0c.png";